import React from 'react';
import { ChatWorkspaceCanvasSection } from '@/chat/ui/index.js';

function canvasPanelProps(props) {
  const defaults = {
    canvasSourcingLoading: false,
    canvasAnalysisPending: false,
    canvasContentSettling: false,
    canvasArtifactDocument: {},
    canvasCollectedCount: 0,
    canvasDisplayLines: [],
    canvasFieldRows: [],
    canvasRevisionEntries: [],
    canvasRevisionControls: {},
    canvasDraftEditing: false,
    canvasDraftEditorValue: '',
    canvasHighlights: [],
    canvasManualControlsEnabled: false,
    canvasProgressPercent: 0,
    canvasWorkflowProjection: {},
    handleCanvasApplyRevision: () => {},
    setCanvasDraftEditorValue: () => {},
    handleCanvasCancelEdit: () => {},
    handleCanvasSaveEdit: () => {},
    handleCanvasStartEdit: () => {},
    handleCanvasToolbarAction: () => {},
  };
  return {
    ...props,
    ...Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [
      key, props[key] === undefined ? fallback : props[key],
    ])),
  };
}

export default function AppCanvasPanel(props) {
  const {
    artifactReadState,
    canvasActiveTabKey,
    showCanvasPanel,
    resolvedUILabels,
    canvasFullscreenOpen,
    canvasTabs,
    resolvedCanvasEvidenceTabKey,
    canvasEvidenceSummary,
    canvasEvidenceItems,
    canvasFocusEvidenceAnchorId,
    canvasSourcingLoading,
    canvasSourcingHasMore,
    canvasSourcingLoadingMore,
    onCanvasSourcingLoadMore,
    canvasReportTemplate,
    canvasAnalysisPending,
    canvasContentSettling,
    resolvedCanvasAnalysisPayload,
    canvasArtifactDocument,
    canvasCollectedCount,
    canvasDisplayLines,
    canvasFieldRows,
    canvasRevisionEntries,
    canvasRevisionControls,
    canvasDraftEditing,
    canvasDraftEditorValue,
    canvasHighlights,
    canvasManualControlsEnabled,
    canvasProgressPercent,
    canvasWorkflowProjection,
    inputState,
    handleCanvasApplyRevision,
    setCanvasDraftEditorValue,
    handleCanvasCancelEdit,
    handleCanvasSaveEdit,
    handleCanvasStartEdit,
    handleCanvasToolbarAction,
    setCanvasActiveTabKey,
    setCanvasFullscreenOpen,
    setShowCanvasPanel,
    themeTokens,
  } = canvasPanelProps(props);
  return (
    <ChatWorkspaceCanvasSection
      artifactReadState={artifactReadState}
      canvasPanelErrorFallback={null}
      handleCanvasRenderError={() => {}}
      canvasActiveTabKey={canvasActiveTabKey}
      showCanvasPanel={showCanvasPanel}
      canvasCollectedCount={canvasCollectedCount}
      canvasDisplayLines={canvasDisplayLines}
      canvasDraftEditing={canvasDraftEditing}
      canvasDraftEditorValue={canvasDraftEditorValue}
      canvasHighlights={canvasHighlights}
      resolvedUILabels={resolvedUILabels}
      canvasFieldRows={canvasFieldRows}
      canvasRevisionEntries={canvasRevisionEntries}
      canvasRevisionControls={canvasRevisionControls}
      canvasFullscreenOpen={canvasFullscreenOpen}
      canvasManualControlsEnabled={canvasManualControlsEnabled}
      canvasProgressPercent={canvasProgressPercent}
      canvasWorkflowProjection={canvasWorkflowProjection}
      canvasTabs={canvasTabs}
      canvasEvidenceTabKey={resolvedCanvasEvidenceTabKey}
      canvasEvidenceSummary={canvasEvidenceSummary}
      canvasEvidenceItems={canvasEvidenceItems}
      canvasFocusEvidenceAnchorId={canvasFocusEvidenceAnchorId}
      canvasSourcingLoading={canvasSourcingLoading}
      canvasSourcingHasMore={canvasSourcingHasMore}
      canvasSourcingLoadingMore={canvasSourcingLoadingMore}
      onCanvasSourcingLoadMore={onCanvasSourcingLoadMore}
      canvasReportTemplate={canvasReportTemplate}
      canvasAnalysisPending={canvasAnalysisPending}
      canvasContentSettling={canvasContentSettling}
      resolvedCanvasAnalysisPayload={resolvedCanvasAnalysisPayload}
      canvasArtifactDocument={canvasArtifactDocument}
      inputState={inputState}
      canvasWorkspaceFullscreenMode={canvasFullscreenOpen === true}
      isCompactLayout={false}
      handleCanvasApplyRevision={handleCanvasApplyRevision}
      setCanvasActiveTabKey={setCanvasActiveTabKey}
      setCanvasDraftEditorValue={setCanvasDraftEditorValue}
      handleCanvasCancelEdit={handleCanvasCancelEdit}
      setCanvasFullscreenOpen={setCanvasFullscreenOpen}
      setCanvasPanelOpen={setShowCanvasPanel}
      handleCanvasSaveEdit={handleCanvasSaveEdit}
      handleCanvasStartEdit={handleCanvasStartEdit}
      handleCanvasToolbarAction={handleCanvasToolbarAction}
      themeTokens={themeTokens}
    />
  );
}
